import { useNavigate } from "react-router-dom";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import Et3CustomizedButton from "../../../../../core/et3-button/Et3CustomizedButton";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";

const UserCounterIndex = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const isVisible = getUserAdvancedStore().userIDs.get().length > 0;
  const index = getUserAdvancedStore().currentIndex.get();
  const navigate = useNavigate();
  const pathname = window.location.pathname;

  return isVisible ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1500}
      height={45}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-end"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={200}
        height={45}
        fDirection="row"
        alignItems="center"
        justifyContent="space-between"
        color={colors.all.bondiBlue}
        style={{
          color: colors.all.white,
          borderRadius: 20
        }}
        onClick={() => {}}
      >
        <Et3CustomizedButton
          style={{
            color: colors.all.white
          }}
          withShadow={false}
          width={30}
          height={30}
          fDirection="row"
          justifyContent="center"
          alignItems="center"
          isEnabled={true}
          color={colors.all.transparent}
          onClick={() => {
            getUserAdvancedStore().setPrevUser();
            navigate({
              pathname: pathname,
              search: `?id=${getUserAdvancedStore().currentUserId.get()}`
            });
          }}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={20}
            text={"<"}
            isSpan={false}
            color={colors.all.white}
            style={{}}
          />
        </Et3CustomizedButton>
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={20}
          text={`${index + 1} / ${getUserAdvancedStore().userIDs.get().length}`}
          isSpan={false}
          color={colors.all.white}
          style={{}}
        />
        <Et3CustomizedButton
          style={{
            color: colors.all.white
          }}
          withShadow={false}
          width={30}
          height={30}
          fDirection="row"
          justifyContent="center"
          alignItems="center"
          isEnabled={true}
          color={colors.all.transparent}
          onClick={() => {
            getUserAdvancedStore().setNextUser();
            navigate({
              pathname: pathname,
              search: `?id=${getUserAdvancedStore().currentUserId.get()}`
            });
          }}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={20}
            text={">"}
            isSpan={false}
            color={colors.all.white}
            style={{}}
          />
        </Et3CustomizedButton>
      </ET3Div>
    </ET3Div>
  ) : null;
});
export default UserCounterIndex;
